import { openTabListGet, openedTabListSet } from '@/service/userdata-service';
import router from '@/router';
import { reactive } from 'vue';

const tabsData = reactive({
    focusedTab: {
        src: '/infoenergo/assets/home.svg',
        name: 'home-view',
        buttonCloseHide: true,
        viewId: 'home-view',
        routeName: 'home-view',
        isDirty: false,
        userData: {
            changes: [],
            data: {},
        },
    },
    openedTabs: [
        {
            src: '/infoenergo/assets/home.svg',
            name: 'home-view',
            buttonCloseHide: true,
            viewId: 'home-view',
            routeName: 'home-view',
            isDirty: false,
        },
    ],
});

export const getHomeView = () => {
    let result;
    if (Array.isArray(tabsData.openedTabs)) {
        result = tabsData.openedTabs?.find(item => item.viewId === 'home-view');
    } else {
        result = tabsData.openedTabs.openedTabs?.find(item => item.viewId === 'home-view');
    }

    return result;
};
export const getFocusedTab = () => {
    return JSON.parse(JSON.stringify(tabsData.focusedTab));
};
export const setFocusedTab = tab => {
    tabsData.focusedTab = tab ? tab : tabsData.focusedTab;
};

export const getFocusedViewId = () => {
    return tabsData.focusedTab?.viewId;
};

export const getOpenedTabs = () => {
    let filteredTabs;
    if (Array.isArray(tabsData.openedTabs)) {
        filteredTabs = tabsData.openedTabs?.filter(tab => tab.viewId !== undefined);
    } else {
        filteredTabs = tabsData.openedTabs.openedTabs?.filter(tab => tab.viewId !== undefined);
    }

    return filteredTabs;
};
export const setOpenedTabs = value => {
    tabsData.openedTabs = value;
};

export const addOpenedTab = tab => {
    Array.isArray(tabsData.openedTabs) ? tabsData.openedTabs.push(tab) : tabsData.openedTabs.openedTabs.push(tab);
};

export const removeTab = removeTab => {
    const openedTabs = getOpenedTabs().filter(tab => tab.routePath !== removeTab.routePath);
    console.log('getOpenedTabs()', getOpenedTabs());
    setOpenedTabs(openedTabs);
};

export const setUserData = userData => {
    if (!userData) {
        userData = {};
    }
    if (tabsData.focusedTab) {
        tabsData.focusedTab.userData = userData;
    } else {
        new Error(`tabsData.focusedTab undefined "fc2a1e8e-89b1-410d-a2b2-a880f0a9304e"`);
    }
};

export const addTabs = tabs => {
    if (!getOpenedTabs()?.length) {
        setOpenedTabs([
            {
                src: '/infoenergo/assets/home.svg',
                name: 'home-view',
                buttonCloseHide: true,
                viewId: 'home-view',
                routeName: 'home-view',
            },
        ]);
    }
    for (const tab of tabs) {
        // если таб уже совпадает с каким-то из таб бара, то он уже не добавится заново
        const match = getOpenedTabs().some(openedTab => openedTab.routePath === tab.routePath);
        if (!match) {
            addOpenedTab(tab);
            setFocusedTab(tab);
        }
    }
};
export async function saveOpenedTabs() {
    const args = {
        tabs: getOpenedTabs().filter(tab => {
            return tab.name !== 'home-view';
        }),
        focused: getFocusedTab(),
    };
    await openedTabListSet(args);
}

export async function loadTabs() {
    const data = await openTabListGet();
    if (data) {
        addTabs(data.openedTabs || []);
        setFocusedTab(data.focusedTab);
        return true;
    }
    return false;
}
const computeTitle = currentRoute => {
    if (currentRoute) {
        if (currentRoute.name === 'home-view') return '';

        const title = currentRoute.meta.title;
        return title;
    }
    return 'NOT DEFINED TAB VIEW';
};

const getParentTab = startPath => {
    let openedTab = Array.isArray(tabsData.openedTabs) ? tabsData.openedTabs : tabsData.openedTabs.openedTabs;
    for (const tab of openedTab) {
        if (tab.routePath) {
            if (tab.routePath.startsWith(startPath)) {
                return tab;
            }
        }
    }
    return null;
};
export function createNewTab(routeName, routePath, params) {
    if (routePath.startsWith('/infoenergo/nsi-view/')) {
        const nsiTab = getParentTab('/infoenergo/nsi-view/');
        if (nsiTab !== null) {
            nsiTab.title = tabTitle ? tabTitle : nsiTab.title;
            setFocusedTab(nsiTab);
            tabTitle = '';
            return;
        }
    }
    const focusedTab = getFocusedTab();
    if (focusedTab) {
        setUserData();
    }
    let _route;
    const routesArr = router.getRoutes();
    for (const r of routesArr) {
        if (r.path.split('&')[0] === routePath.split('&')[0]) {
            _route = r;
            break;
        }
    }
    // let _route = router
    //     .getRoutes()
    //     .find(rout => rout.name === routeName && rout.meta !== undefined && rout.meta?.layout?.name === 'main-layout');

    // если view не используется в main-layout
    if (!_route) {
        return { result: false, uuid: '167ec275-bc72-4167-a5f6-7cfc2e13414a', msg: 'cant find view in default views' };
    }

    const viewId = _route.meta.viewId;
    const title = tabTitle ? tabTitle : computeTitle(_route);
    const isDirty = false;
    tabTitle = '';
    const tab = { viewId, title, routeName, routePath, isDirty, params };
    addOpenedTab(tab);
    const view = getOpenedTabs().find(tab => tab.routePath === routePath);
    setFocusedTab(view);
}
let tabTitle = '';
export const setTabTitle = text => {
    tabTitle = text;
};

export const setTabRoute = routeName => {
    tabsData.focusedTab.routeName = routeName;
};

// обработка роутинга при переходе на другой таб (смена фокуса таба)
export async function tabFocusChange(tab) {
    // TODO: не работает фокусировка рефреше
    // TODO: надо бы добавить выделение жирным на объекты где есть uaserData.changes

    const routePath = router.currentRoute.value?.path;
    saveTabContent = null;
    if (tab.routeName === 'home-view') {
        setFocusedTab(getHomeView());
        await saveOpenedTabs();
    } else {
        let currentTub;
        if (Array.isArray(tabsData.openedTabs)) {
            currentTub = tabsData.openedTabs.find(tab => tab.routePath === routePath);
        } else {
            currentTub = tabsData.openedTabs.openedTabs.find(tab => tab.routePath === routePath);
        }
        // добавление нового таба в таб-бар
        if (!currentTub) {
            createNewTab(tab.routeName, routePath, tab.params);
        }
        // смена текущего таба на другой из уже существующих
        else {
            setFocusedTab(currentTub);
            await saveOpenedTabs();
        }
    }
}

export function findTabByPath(path) {
    let tab;
    if (Array.isArray(tabsData.openedTabs)) {
        tab = tabsData.openedTabs.find(itemTab => itemTab.routePath === path);
    } else {
        tab = tabsData.openedTabs.openedTabs.find(itemTab => itemTab.routePath === path);
    }
    return tab;
}

let funcRefreshOpenTabs = null;
export function getFuncRefreshOpenTabs() {
    return funcRefreshOpenTabs;
}
export function setFuncRefreshOpenTabs(func) {
    if (funcRefreshOpenTabs) {
        new Error('Reset value banned, function already set, error: 920d953f-19b1-4557-98fe-d1df40652b5e');
    }
    funcRefreshOpenTabs = func;
}

let funcChangeRoute = null;
export function getFuncChangeRoute() {
    return funcChangeRoute;
}
export function setFuncChangeRoute(func) {
    if (funcChangeRoute) {
        new Error('Reset value banned, function already set, error: 020d953f-19b1-4557-98fe-daaf40652b5e');
    }
    funcChangeRoute = func;
}

export let saveTabContent = null;
export let prepareChangesForSaving = null;
export let isTabReadyToSave = false;
export let childViewId = null;
export let formViewName = null;

export function setIsDirtyValue(value, save, prepareChanges, viewId, formViewId) {
    let currOpenTab;
    if (Array.isArray(tabsData.openedTabs)) {
        currOpenTab = tabsData.openedTabs.find(tab => tab.viewId === formViewId);
    } else {
        currOpenTab = tabsData.openedTabs.openedTabs.find(tab => tab.viewId === formViewId);
    }
    if (currOpenTab) {
        currOpenTab.isDirty = value;
        tabsData.focusedTab = currOpenTab; // Обновить focusedTab
    }

    saveTabContent = save;
    childViewId = viewId;
    prepareChangesForSaving = prepareChanges;
    formViewName = formViewId;
}

export function setTabReadyToSaveValue(value) {
    isTabReadyToSave = value;
}

export let tabState = {};

export function resetTabState() {
    tabState = {};
}
